import TopSection from "../../compontents/common/TopSection";
import MainSection from "../../compontents/common/MainSection";
import ProjectGrid from "../../compontents/project/ProjectGrid";

export default function ProjectsPage() {
    return (
        <>
            <TopSection 
                title="Featured"
                desc="Selection of experienced product design solutions and innovative digital concepts"
                contentTranslateY={-10}
                descBottom={16}
            /> 

            <MainSection paddingAmount={'0px 0px 150px'}>
                <ProjectGrid />
            </MainSection>
        </>
    );
}
